import React from 'react';
import {
    Select,
    MenuItem,
    ListSubheader,
} from '@material-ui/core';
import {
    OnSelectChangeEvent,
    OnMouseDivEvent,
} from '@pluto/@types';

export interface SelectMenuItem {
    label: string;
    value?: string | number;
}

export interface SelectMenuGroup {
    group?: string;
    items: SelectMenuItem[];
}

export type QCTabsSelectVariant = 'filled' | 'outlined' | 'standard';

export interface QCTabsSelectProps {
    onChange: (event: OnSelectChangeEvent) => void;
    menuItems: SelectMenuGroup[];
    currentValue?: unknown;
    autoFocus: boolean;
    emptyLabel?: string;
    variant?: QCTabsSelectVariant;
    id: string;
}

export default function QCTabsSelect(props: QCTabsSelectProps) {
    const {
        onChange,
        menuItems,
        currentValue,
        autoFocus,
        emptyLabel,
        id,
        variant = 'standard',
    } = props;
    const value = (currentValue !== undefined && currentValue !== null) ? currentValue : '';
    const menuOptions = menuItems.map(getMenu);
    
    return (
        <Select
            id={id}
            value={value}
            displayEmpty={Boolean(emptyLabel)}
            autoFocus={autoFocus}
            variant={variant}
            onChange={onChange}
            onClick={stopPropagation}
        >
            {emptyLabel && (
                <MenuItem
                    disabled
                    value=""
                >
                    <em>
                        {emptyLabel}
                    </em>
                </MenuItem>
            )}
            {menuOptions}
        </Select>
    );
}

export const stopPropagation = (event: OnMouseDivEvent) => { event.stopPropagation(); };

export const getMenu = (menu: SelectMenuGroup) => {
    const {group, items} = menu;
    const menuItems = items.map(getMenuItem);
    
    if (!group)
        return menuItems;
    
    const subHeader = getSubHeader(group);
    
    return [subHeader, menuItems];
};

export const getSubHeader = (header: string) => {
    return (
        <ListSubheader>{header}</ListSubheader>
    );
};

export const getMenuItem = (item: SelectMenuItem) => {
    return (
        <MenuItem
            key={item.value}
            value={item.value}
        >
            {item.label}
        </MenuItem>
    );
};
